import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {CommonService} from "../../../core/services/common.service";
import {HttpClientService} from "../../../core/services/http-client.service";
import {ToastService} from "../../../core/services/toast.service";

@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.css']
})
export class ListingComponent implements OnInit{
  webListings: any[] = [];
  metaData: any;
  loading: boolean = true;
  selectedFilters: any = {};

  constructor(private router: Router, private route: ActivatedRoute, private common: CommonService, private http: HttpClientService, private toast: ToastService) {}

  ngOnInit() {
    this.route.url.subscribe((url) => {
      this.getFofoListing(this.route.snapshot.paramMap.get('page'));
    })
  }

  getFofoListing(page) {
    this.http.get('store/listing/'+page).subscribe((data) => {
      this.metaData = data.response;
      this.webListings = data.response.fofoCatalogResponses
        /*.map((list) => {
          list.items = list.items.filter((item) => item.availability > 0);
          return list;
        })*/
        .filter((list) => list.items.length > 0);
      this.loading = false;
    }, (error) => {
      this.loading = false;
    });
  }

  navigateToPage(text) {
    this.common.obj.q = text;
    this.router.navigateByUrl(`/search?`+this.common.stringParams(this.common.obj))
  }

  applyFilter(filter: any) {
    this.selectedFilters = filter;
    if ('price' in filter) {
      this.webListings = this.common.sortByPrice(filter.price, this.webListings);
    }
  }

}
